import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * 复制文本库
 * @author colynchen
 * @example
 * new Clipboard({
 *   text: 'hello, world',
 *   success: function() {},
 *   error: function() {}
 * })
 */
import select from 'select';

var Clipboard = /*#__PURE__*/function () {
  function Clipboard() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Clipboard);

    this.text = options.text;
    this.action = options.action || 'copy';
    this.success = options.success;
    this.error = options.error;
    this.container = options.container || document.body;
    this.initSelection();
  } // 创建节点


  _createClass(Clipboard, [{
    key: "initSelection",
    value: function initSelection() {
      var _this = this;

      var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
      this.removeFake();

      this.fakeHandlerCallback = function () {
        return _this.removeFake();
      };

      this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
      this.fakeElem = document.createElement('textarea'); // Prevent zooming on iOS

      this.fakeElem.style.fontSize = '12pt'; // Reset box model

      this.fakeElem.style.border = '0';
      this.fakeElem.style.padding = '0';
      this.fakeElem.style.margin = '0';
      this.fakeElem.style.position = 'absolute';
      this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
      var yPosition = window.pageYOffset || document.documentElement.scrollTop;
      this.fakeElem.style.top = "".concat(yPosition, "px");
      this.fakeElem.setAttribute('readonly', '');
      this.fakeElem.value = this.text;
      this.container.appendChild(this.fakeElem);
      this.selectedText = select(this.fakeElem);
      this.copyText();
    } // 移除元素

  }, {
    key: "removeFake",
    value: function removeFake() {
      if (this.fakeHandler) {
        this.container.removeEventListener('click', this.fakeHandlerCallback);
        this.fakeHandler = null;
        this.fakeHandlerCallback = null;
      }

      if (this.fakeElem) {
        this.container.removeChild(this.fakeElem);
        this.fakeElem = null;
      }
    } // 复制文本

  }, {
    key: "copyText",
    value: function copyText() {
      var succeeded = false;

      try {
        document.execCommand(this.action);
        succeeded = true;
      } catch (e) {
        succeeded = false;
      }

      var callback = this[succeeded ? 'success' : 'error'];

      if (typeof callback === 'function') {
        callback({
          action: this.action,
          text: this.text
        });
      }
    }
  }]);

  return Clipboard;
}();

export { Clipboard as default };